<template>
    <tbody>
        <tr>
            <td>
                <span>{{ value.contacts_list.id }}</span>
            </td>
            <td>
                <a :href="value.contacts_list.route">{{ value.contacts_list.name }}</a>
            </td>
            <td>
                <span
                    title="Total"
                    class="label bg-gray"
                    >{{ value.contacts_count_total }}</span
                >
            </td>
            <td>
                <span
                    title="Non-Clickers"
                    class="label bg-light-blue"
                    >{{ value.contacts_non_clickers_percent }}</span
                >
                <span
                    title="Non-Clickers"
                    class="label bg-aqua-active"
                    >{{ value.contacts_count_non_clickers }}</span
                >
            </td>
            <td>
                <span
                    title="Non Clickers With 0 Messages"
                    class="label bg-light-blue"
                    >{{ value.messages_0_contacts_percent }}</span
                >
                <span
                    title="Non Clickers With 0 Messages"
                    class="label bg-aqua-active"
                    >{{ value.messages_0_contacts_count }}</span
                >
                <span
                    title="Non Clickers Undelivered With 0 Messages"
                    class="label bg-yellow"
                    >{{ value.messages_0_contacts_undelivered_count }}</span
                >
            </td>
            <td>
                <span
                    title="Non Clickers With 1-3 Messages"
                    class="label bg-light-blue"
                    >{{ value.messages_3_contacts_percent }}</span
                >
                <span
                    title="Non Clickers With 1-3 Messages"
                    class="label bg-aqua-active"
                    >{{ value.messages_3_contacts_count }}</span
                >
                <span
                    title="Non Clickers Undelivered With 1-3 Messages"
                    class="label bg-yellow"
                    >{{ value.messages_3_contacts_undelivered_count }}</span
                >
            </td>
            <td>
                <span
                    title="Non Clickers With 4-6 Messages"
                    class="label bg-light-blue"
                    >{{ value.messages_6_contacts_percent }}</span
                >
                <span
                    title="Non Clickers With 4-6 Messages"
                    class="label bg-aqua-active"
                    >{{ value.messages_6_contacts_count }}</span
                >
                <span
                    title="Non Clickers Undelivered With 4-6 Messages"
                    class="label bg-yellow"
                    >{{ value.messages_6_contacts_undelivered_count }}</span
                >
            </td>
            <td>
                <span
                    title="Non Clickers With 7-9 Messages"
                    class="label bg-light-blue"
                    >{{ value.messages_9_contacts_percent }}</span
                >
                <span
                    title="Non Clickers With 7-9 Messages"
                    class="label bg-aqua-active"
                    >{{ value.messages_9_contacts_count }}</span
                >
                <span
                    title="Non Clickers Undelivered With 7-9 Messages"
                    class="label bg-yellow"
                    >{{ value.messages_9_contacts_undelivered_count }}</span
                >
            </td>
            <td>
                <span
                    title="Non Clickers With 10-15 Messages"
                    class="label bg-light-blue"
                    >{{ value.messages_15_contacts_percent }}</span
                >
                <span
                    title="Non Clickers With 10-15 Messages"
                    class="label bg-aqua-active"
                    >{{ value.messages_15_contacts_count }}</span
                >
                <span
                    title="Non Clickers Undelivered With 10-15 Messages"
                    class="label bg-yellow"
                    >{{ value.messages_15_contacts_undelivered_count }}</span
                >
            </td>
            <td>
                <span
                    title="Non Clickers With >15 Messages"
                    class="label bg-light-blue"
                    >{{ value.more_messages_contacts_percent }}</span
                >
                <span
                    title="Non Clickers With >15 Messages"
                    class="label bg-aqua-active"
                    >{{ value.more_messages_contacts_count }}</span
                >
                <span
                    title="Non Clickers Undelivered With >15 Messages"
                    class="label bg-yellow"
                    >{{ value.more_messages_contacts_undelivered_count }}</span
                >
            </td>
            <td class="text-right">
                <span>{{ value.date }}</span>
            </td>
        </tr>
    </tbody>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>
